module.exports = __webpack_public_path__ + "static/media/CreateAppIcon.f121eb43.svg";